import { router, useLocalSearchParams } from 'expo-router';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { useAuth } from '../../../../src/contexts/AuthContext';
import { useTranslation } from '../../../../src/contexts/TranslationContext';
import { AgentWizard } from '../../../../src/features/voice-agents/components/AgentWizard';
import { useVoiceAgent } from '../../../../src/features/voice-agents/hooks';
import type { VoiceAgent } from '../../../../src/features/voice-agents/types';
import { colors } from '../../../../src/theme/colors';

export default function EditVoiceAgentScreen() {
  const { t } = useTranslation();
  const { id } = useLocalSearchParams<{ id: string }>();
  const { currentOrganization } = useAuth();
  const orgId = currentOrganization?.id ?? '';

  const { data: agent, isLoading } = useVoiceAgent(id ?? '', orgId);

  function handleComplete(updated: VoiceAgent) {
    router.replace(`/voice-agents/${updated.id}`);
  }

  function handleCancel() {
    router.back();
  }

  if (isLoading) {
    return (
      <View style={styles.center} accessible accessibilityLabel={t('voiceAgents.edit.loadingA11y')}>
        <ActivityIndicator color={colors.primary.main} size="large" />
      </View>
    );
  }

  return (
    <View
      style={styles.root}
      accessibilityLabel={`${t('voiceAgents.edit.screenA11y')} ${agent?.name ?? ''}`}
    >
      {agent ? (
        <AgentWizard
          organizationId={orgId}
          agent={agent}
          onComplete={handleComplete}
          onCancel={handleCancel}
        />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: colors.background.primary,
  },
  center: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
